<template>
  <div>
    <div class="container">

      <div class="columns mt-01" v-for="(videos, i) in chunkedVideos">
        <div class="column is-6" v-for="(v, i) in videos">
          <div class="video-container">
            <iframe :src="v.video" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
          </div>
          <span class="is-size-5 mt-01">{{ v.title }}</span>
        </div>

      </div>

      <pagination v-if="links!=null" :links="links" :meta="meta" @paginate="videoSearch()"></pagination>


    </div>


  </div>
</template>

<script>
import axios from 'axios';
import Pagination from '@/components/layouts/partials/pagination'
import VueLodash from 'vue-lodash'

export default {
  name: 'Videos',
  data () {
    return {
      videos:[],
      links:[],
      meta:{'current_page':1},
    }
  },
  components: {
    'pagination': Pagination,
  },
  computed: {
   chunkedVideos () {
     return _.chunk(this.videos,2)
   }
  },
  methods:{
    videoSearch(){
      var self = this;
      axios.post(process.env.API_URL_V1+'video?page='+this.meta.current_page+'&api_token='+process.env.API_TOKEN_V1, {type_web:'croc'})
      .then(function (response) {
        self.videos=response.data.data;
        self.links=response.data.links;
        self.meta=response.data.meta;
      })
      .catch(function (error) {
      });
    },
  },
  created :function(){
    this.videoSearch();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Videos.vue